<template lang="html">
  <div class="version">
    <h2>{{`${$_syscfg.title.toUpperCase()} 版本信息`}}</h2>
    <div class="info">
      <div v-for="item in list" class="gen">
        <p>{{item.version_id}} - {{item.raw_add_time}}</p>
        <p v-for="item1 in item.info">{{item1}}</p>
        <!-- <p>1、“权限管理”“用户列表”编辑用户信息交互修改（可参考需求卡2021-4-12 “权限管理”“用户列表”编辑用户信息交互修改）刘海敏</p>
        <p>2、“权限管理”-“角色管理”增加删除功能 （可参考需求卡2021-4-12  “权限管理”-“角色管理”增加删除功能）刘海敏</p>
        <p>3、后台信源添加时需要查重名校验(可参考需求卡2021-4-12 后台信源添加时需要查重名校验  )刘海敏</p>
        <p>4、人脸识别增加下载/查看/删除功能（可参考需求卡2021-4-12“监控管理”-“人脸识别记录”管理开发） 刘海敏</p>
        <p>5、正常转码/三件套横屏转码/三件套竖屏转码/送体育转码2.0（需要同时验证1.0和2.0） 刘海敏</p>
        <p>6、正常转码/三件套横屏转码/三件套竖屏转码/送体育转码重新获取信息2.0（可在后台转码回调 重新获取信息）刘海敏</p>
        <p>7、线索列表/发布库/报道库列表顶部搜索栏增加“全部”搜索 参考需求文档2021-4-6 邵骏杰</p>
        <p>8、报道库列表删选字段增加日期选项 后台网站可以配置 参考需求文档2021-4-6 邵骏杰</p>
        <p>9、@radio发布稿推送X1增加音频转码 转码完成后稿件再推送至X1 使用流程和体验不变 参考需求文档2021-4-6 邵骏杰</p>
        <p>10、后台连线维护/演播室配置 删除状态栏 邵骏杰</p>
        <p>11、APP连线SDK模式修改 参考2021-4-6需求卡 邵骏杰</p>
        <p>12、pr增加上传接口 并且校验用户空间 参考 邵骏杰</p>
        <p>13、为pr客户端开发epm前端断点续传上传组件（jquery版本）兼容客户端上传样式 葛盛陶</p>
        <p>14、报道库小康生活日期筛选模块开发 葛盛陶</p>
        <p>15、前端通用搜索栏关键词筛选时无法清除问题修复 葛盛陶</p>
        <p>16、禅道前端bug修复 葛盛陶</p> -->
      </div>
      <div class="gen">
        <p>v3.0.0.13 - 20210416</p>
        <p>web端：</p>
        <p>1、“权限管理”“用户列表”编辑用户信息交互修改（可参考需求卡2021-4-12 “权限管理”“用户列表”编辑用户信息交互修改）刘海敏</p>
        <p>2、“权限管理”-“角色管理”增加删除功能 （可参考需求卡2021-4-12  “权限管理”-“角色管理”增加删除功能）刘海敏</p>
        <p>3、后台信源添加时需要查重名校验(可参考需求卡2021-4-12 后台信源添加时需要查重名校验  )刘海敏</p>
        <p>4、人脸识别增加下载/查看/删除功能（可参考需求卡2021-4-12“监控管理”-“人脸识别记录”管理开发） 刘海敏</p>
        <p>5、正常转码/三件套横屏转码/三件套竖屏转码/送体育转码2.0（需要同时验证1.0和2.0） 刘海敏</p>
        <p>6、正常转码/三件套横屏转码/三件套竖屏转码/送体育转码重新获取信息2.0（可在后台转码回调 重新获取信息）刘海敏</p>
        <p>7、线索列表/发布库/报道库列表顶部搜索栏增加“全部”搜索 参考需求文档2021-4-6 邵骏杰</p>
        <p>8、报道库列表删选字段增加日期选项 后台网站可以配置 参考需求文档2021-4-6 邵骏杰</p>
        <p>9、@radio发布稿推送X1增加音频转码 转码完成后稿件再推送至X1 使用流程和体验不变 参考需求文档2021-4-6 邵骏杰</p>
        <p>10、后台连线维护/演播室配置 删除状态栏 邵骏杰</p>
        <p>11、APP连线SDK模式修改 参考2021-4-6需求卡 邵骏杰</p>
        <p>12、pr增加上传接口 并且校验用户空间 参考 邵骏杰</p>
        <p>13、为pr客户端开发epm前端断点续传上传组件（jquery版本）兼容客户端上传样式 葛盛陶</p>
        <p>14、报道库小康生活日期筛选模块开发 葛盛陶</p>
        <p>15、前端通用搜索栏关键词筛选时无法清除问题修复 葛盛陶</p>
        <p>16、禅道前端bug修复 葛盛陶</p>
      </div>
      <div class="gen">
        <p>v3.0.0.12 - 20210409</p>
        <p>web端：</p>
        <p>1、关闭部门功能</p>
        <p>2、音频合成接口对接（验证音频合成1.0和2.0）</p>
        <p>3、音频剪辑接口对接（验证音频剪辑1.0和2.0）</p>
        <p>4、错别字检测接口（错别字检测1.0和2.0）</p>
        <p>5、语音合成一二期兼容 </p>
        <p>6、报道库筛选添加</p>
        <p>7、前端BUG修复</p>
        <p>8、@radio推送车载对接腾讯云</p>
        <p>9、公共服务平台回调逻辑修改（视频转码 人脸识别 语音识别 语音合成 互联互通 文件技审 音频剪辑）体验与原来保持一致</p>
      </div>
      <div class="gen">
        <p>v3.0.0.11 - 20210402</p>
        <p>web端：</p>
        <p>1、送看看逻辑修改</p>
        <p>2、新媒体稿计算正文字数和语速显示</p>
        <p>3、纪录小康工程详情页，不显示信源</p>
        <p>4、推送阿基米德修改 素材上传失败三次重试 素材上传失败不推送稿件标记推送失败
在后台推送异常管理可以查看并且重发</p>
        <p>5、流媒体回调对接 </p>
        <p>6、素材共享下载文件模式修改（不影响使用 功能保持一致）</p>
        <p>7、优化后台系统频繁登出的bug</p>
        <p>8、角色的反抄删除</p>
        <p>9、部门的报道配置（增加反抄路径配置）</p>
        <p>10、后台“监控管理”优化</p>
        <p>11、后台“部门管理”修改</p>
        <p>12、纪录小康工程内容分类 删除功能逻辑修改</p>
        <p>13、EP-player重新对接</p>
      </div>
      <div class="gen">
        <p>v.3.0.0.8 - 20210326</p>
        <p>web端：</p>
        <p>1、美摄转码数量限制</p>
        <p>2、文件上传断点续传</p>
        <p>3、后台部部门角色列表添加用户名搜索，列表增加手机号显示</p>
        <p>4、视频人脸识别/图像人脸识别接口兼容公共服务平台2.0</p>
        <p>5、操作日志详情 </p>
        <p>6、素材列表，区块样式及交互更改</p>
        <p>7、警示样式添加</p>
        <p>8、详情页面预览多媒体数据顺序修改</p>
        <p>9、多租户增加稿件类型配置 同步到租户端</p>
        <p>10、后台运维模块稿件类型配置从多租户获取</p>
        <p>11、添加用户权限中心回馈提示明细</p>
        <p>12、送看看不通过公共服务平台，本地直接推送</p>
      </div>
      <div class="gen">
        <p>v.3.0.0.7 - 20210319</p>
        <p>web端：</p>
        <p>1、后台操作日志详情页</p>
        <p>2、报道删除关联素材逻辑修改</p>
        <p>3、后台默认头像显示系统默认图</p>
        <p>4、部门“基础信息”配置</p>
        <p>5、小康工程上传报道bug修复 </p>
        <p>6、小康工程稿件配置bug修复</p>
        <p>7、上传监控文件大小收录</p>
        <p>8、删除人员搜索bug修复</p>
        <p>9、素材视频封面图接口对接</p>
        <p>10、一键合成在消息列表里要有百分比进度</p>
        <p>11、列表页面添加加载骨架屏</p>
        <p>12、素材列表添加合成百分比，空列表logo图</p>
        <p>13、首页快捷卡片添加折叠效果</p>
        <p>14、素材详情页操作按钮优化</p>
        <p>15、报道/线索/发布稿件正文过滤表情符号</p>
      </div>
      <div class="gen">
        <p>v.3.0.0.6 - 20210312</p>
        <p>web端：</p>
        <p>1、报道库筛选增加内容分类</p>
        <p>2、后台增加报道库筛选配置</p>
        <p>3、发布库推送平台增加EP-player对接FTP上传</p>
        <p>4、多租户平台模块管理增加移动端 控制web端app相关图标</p>
        <p>5、素材模块增加首播日期字段 </p>
        <p>6、报道模块新增“小康工程稿‘</p>
        <p>7、报道列表增加内容分类检索</p>
        <p>8、后台上传监控日志增加详情和回收状态筛选</p>
        <p>9、增加公共串联单模块</p>
      </div>
      <div class="gen">
        <p>v.3.0.0.5 - 20210305</p>
        <p>web端：</p>
        <p>1、修复侧边菜单折叠后，点子菜单，所有菜单都会展开</p>
        <p>2、后台”信息运维“里的”美摄快编“都改成”在线快编“</p>
        <p>3、“监控管理”的“在线统计”增加“快编PC端”人数使用统计</p>
        <p>4、多租户管理平台添加快编转码配置（配置每个租户可并发的转码数量）</p>
        <p>5、文件上传补全字段+后台增加所属模块</p>
        <p>6、后台部门里分配里分配人员添加人员，检索界面，删除前次检索内容，会把之前检索的删除bug修复</p>
        <p>7、各租户上传失败、上传没完成的文件清理</p>
        <p>8、快编支持导入gif和视频导出gif</p>
        <p>9、多租户增加媒资回调模块 权限分配控制首页div和个人设置绑定媒资账号</p>
        <p>10、推送体育流程增加视频文件转码</p>
        <p>11、推送阿基米德流程修改：不下载文件直接从挂盘上传（@radio正式环境上线前需要挂盘）</p>
        <p>12、信源无法被共享bug修复</p>
        <p>13、修复推送串联单稿件内部换行bug</p>
        <p>14、图片编辑功能替换新插件</p>
        <p>15、媒资回调权限优化</p>
        <p>16、pr样式修改</p>
        <p>17、前端bug修复</p>
      </div>
      <div class="gen">
        <p>v.3.0.0.4 - 20210226</p>
        <p>web端：</p>
        <p>1、发布库推送平台增加车载系统</p>
        <p>2、素材库标题检索支持搜索素材名/线索名/报道名/发布名</p>
        <p>3、消息中心增加推送消息/增加socket通知提示/稿件一生增加推送结果</p>
        <p>4、后台管理系统增加超管权限控制</p>
        <p>5、视频转码失败视频信息显示</p>
        <p>6、素材模板维护管理</p>
        <p>7、公告增加视频插入</p>
        <p>8、用户删除草稿状态线索/报道/发布时，询问是否同时删除素材功能</p>
        <p>9、公告自动滚屏</p>
        <p>10、公告详情兼容视频</p>
        <p>11、推送消息对接</p>
        <p>12、用户删除草稿状态线索/报道/发布，询问是否同时删除素材功能</p>
      </div>
      <div class="gen">
        <p>v.3.0.0.3 - 20210220</p>
        <p>web端：</p>
        <p>1、后台app版本管理和app版本控制接口</p>
        <p>2、修改语音转文字导出格式</p>
        <p>3、增加线索报道发布浏览记录</p>
        <p>4、优化后台推送异常监控页面显示</p>
        <p>5、PHP大文件上传</p>
        <p>6、对接美摄App功能开发</p>
        <p>7、我的素材页面添加上传进度条</p>
        <p>8、删除二次确认添加</p>
        <p>9、详情页面添加浏览记录</p>
      </div>
      <div class="gen">
        <p>v.3.0.0.2 - 20210208</p>
        <p>web端：</p>
        <p>1、修复后台配置的权限，不能及时生效的问题</p>
        <p>2、修复待处理后面有几个空白页</p>
        <p>3、优化错别字检查二次确认弹框</p>
        <p>4、优化ts文件语音合成功能</p>
        <p>5、新增后台内外网下载权限配置</p>
        <p>6、修复后台管理：用户配置权限，仅读取租户部门信息配置</p>
        <p>7、新增后台管理：修改用户信息密码功能</p>
        <p>8、修复后台无配置时的用户显示权限</p>
        <p>9、修复图片素材编辑后入草稿库问题</p>
        <p>10、修复图片、音频素材直接下载问题</p>
        <p>11、后台增加稿件推送异常监控和重试功能</p>
        <p>12、优化稿件推送功能</p>
        <p>13、优化日志检索同步策略</p>
      </div>
      <div class="gen">
        <p>v2.0.0.159 - 20201109</p>
        <p>web端：</p>
        <p>1、优化下载方式，解决大文件下载造成的页面卡顿问题</p>
      </div>
      <div class="gen">
        <p>v2.0.0.155 - 20200921</p>
        <p>web端：</p>
        <p>1、媒资回调账号绑定和跳转</p>
        <p>2、首页版面调整+全站检索</p>
        <p>4、发布流程衔接</p>
        <p>5、素材人脸识别调整</p>
        <p>6、xnews稿件回推@radio外部稿库</p>
      </div>
      <div class="gen">
        <p>v2.0.0.154 - 20200908</p>
        <p>web端：</p>
        <p>1、我的素材模块添加</p>
        <p>2、多媒体栏样式替换</p>
        <p>3、素材详情模块添加</p>
        <p>4、素材语音识别功能添加</p>
        <p>5、素材人脸识别功能添加</p>
      </div>
      <div class="gen">
        <p>v2.0.0.153 - 20200807</p>
        <p>web端：</p>
        <p>1、编辑器黏贴微信文章样式兼容,图片地址替换</p>
        <p>2、左侧编辑器素材同步添加素材库，素材库删除素材编辑器同步删除</p>
        <p>3、图片编辑移动、旋转、放大缩小效果优化</p>
        <p>4、后台增加下载微信和互联网图片接口</p>
        <p>5、外部稿库采集增加成品新闻</p>
        <p>6、修复app发布审核重复推送消息bug</p>
      </div>
      <div class="gen">
        <p>v2.0.0.152 - 20200723</p>
        <p>web端：</p>
        <p>1、语音合成添加时间戳解决重复提交问题</p>
        <p>2、图片编辑模块添加</p>
        <p>3、已知页面不统一样式修改</p>
        <p>4、修复移动采访文稿内图片不显示</p>
      </div>
      <div class="gen">
        <p>v2.0.0.152 - 20200709</p>
        <p>web端：</p>
        <p>1、@radio登录界面添加弱密码检测</p>
        <p>2、发布模块针对x1平台添加容量检测</p>
        <p>3、发布模块添加信源与作者</p>
        <p>4、修复音频转文字提示素材不存在或已删除问题</p>
        <p>5、右上角二维码修改为后台可配置</p>
        <p>6、修复发布模块标题过长导致显示异常问题</p>
        <p>7、已知页面不统一样式修改</p>
        <p>8、增加X1空间查询接口逻辑</p>
        <p>9、发布增加信源和作者字段</p>
        <p>10、已知bug修复</p>
      </div>
      <div class="gen">
        <p>v2.0.0.151 - 20200624</p>
        <p>web端：</p>
        <p>1、素材库，信源下拉筛选按钮在信源能一行显示的情况下隐藏</p>
        <p>2、音频剪辑页面播放弹窗音频进度拖动功能优化</p>
        <p>3、首页待处理只有一个事件时隐藏右边线</p>
        <p>4、发布库状态栏与列表栏合并成一个整体</p>
        <p>5、发布详情音频样式修改</p>
        <p>6、页面使用错误的icon图标替换</p>
        <p>7、对接推送X1和串联单测试系统</p>
      </div>
      <div class="gen">
        <p>v2.0.0.150 - 20200622</p>
        <p>web端：</p>
        <p>1、修改列表预览图片</p>
        <p>2、修改用户页面角色部门显示</p>
        <p>3、广播音频筛选列表bug修复切换页面清空选项</p>
        <p>4、页面筛选折叠问题修改，折叠按钮再需要的时候出现</p>
        <p>5、音频剪辑bug修复、修复预览音频播放条拉动问题，关闭页面关闭音频播放。</p>
        <p>6、发布审核页隐藏发布按钮</p>
        <p>7、错别字页面样式修改</p>
        <p>8、页面下载按钮修改，点击空白处隐藏</p>
        <p>9、关联页面等各页面样式问题细节调整</p>
        <p>10、PC后台:信息维护：隐藏“考评打分”、“办公提案”、“选题”、“采访管理”、"报道管理“、”资源管理“
”线索库“改为”素材库“
权限管理：角色列表-权限配置内，隐藏采访、报道权限的配置 /部门管理-板块读取隐藏：采访、报道、电视报片、收录\自采\渠道线索、”报道推送设置“、”考评打分设置“、”报道稿件推送设置“</p>
        <p>11、PC后台增加发布管理</p>
        <p>12、已知bug修复</p>
      </div>
      <div class="gen">
        <p>v2.0.0.148 - 20200604</p>
        <p>web端：</p>
        <p>1、预览页面添加</p>
        <p>2、发布模块字段调整</p>
        <p>3、修改姓名栏多角色账号展现方式</p>
        <p>4、发布模块添加部门选项,页面样式修改,添加权限控制发布按钮隐藏判断</p>
        <p>5、对接PE剪辑程序</p>
        <p>6、新建发布预览为空问题修复</p>
        <p>7、素材管理被引用显示不正常修改</p>
        <p>8、首页发布图标修改</p>
        <p>9、用户名片不能显示字段缺失问题修复</p>
        <p>10、xnews后台板块读取配置、报道推送设置、考评打分配置需要增加清空配置的选项</p>
        <p>11、广播音频/融媒体视频对接检索引擎</p>
        <p>12、增加发布话匣子预览功能</p>
        <p>13、增加发布推送话匣子功能</p>
        <p>14、我的发布待审核的稿件显示发布平台</p>
        <p>15、广播音频增加转录节目、融媒体视频增加外场视频、外部稿库增加公共串联单</p>
      </div>
      <div class="gen">
        <p>v2.0.0.147 - 20200518</p>
        <p>web端：</p>
        <p>1、新增模块：发布</p>
        <p>2、首页布局调整，新增入口：创建发布、发布、审核发布，新增最近发布列表</p>
        <p>3、素材列表布局优化调整</p>
        <p>4、报道编辑和线索编辑新增“一键生成标签”功能</p>
        <p>5、添加发布审核小红点、传完自动送审/发布、发布平台控制</p>
        <p>6、预览方法修改</p>
        <p>7、标签逻辑修改</p>
        <p>8、发布编辑增加：修改并发布、送审时发布平台校验</p>
        <p>9、采访库动态监听宽度</p>
        <p>10、推送平台改为推送发布</p>
        <p>11、素材列表页面加上传按钮控制、线索详情名称样式优化、隐藏报片数</p>
        <p>12、互联网线索筛选条件样式调整、报道列表内容区上下两端对齐</p>
        <p>13、优化时间控件滚动条样式、多媒体组件样式优化</p>
        <p>14、素材详情转文字添加判断、详情页样式修改</p>
        <p>15、角色名称数据修改、广播稿隐藏语速设置，广播稿输入区域高度设置</p>
        <p>16、素材详情视频背景加底图；加推送权限判断、假音频合成通知</p>
        <p>17、导出打分下拉框功能添加</p>
        <p>18、发布模块复制按钮位置颜色修改、发布平台一级选项添加选中样式</p>
        <p>19、添加音频剪辑功能</p>
        <p>20、后台网站用户管理增加姓名/用户名检索</p>
        <p>21、后台网站标签管理增加按文稿模块搜索</p>
        <p>22、后台网站面包屑优化 分到三级菜单</p>
        <p>23、后台网站下载监控增加单条数据检索 可按操作用户/下载类型/来源标题检索</p>
        <p>24、后台网站用户列表增加导出功能</p>
        <p>25、后台网站部门列表显示部门人数</p>
        <p>26、后台网站部门人员列表按入库时间倒序显示 列表增加删除人员功能</p>
        <p>27、后台网站操作日志和系统日志接入检索 可按用户名/姓名搜索日志</p>
        <p>28、后台网站权限管理/关联接口增加“增加接口“</p>
        <p>29、后台网站用户详情页添加角色部门选择修改为二级联动选择框</p>
        <p>30、增加音频智能剪辑功能和相关权限配置</p>
        <p>31、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.145 - 20200319</p>
        <p>web端：</p>
        <p>1、网站菜单支持动态配置及列表页模版化改造</p>
        <p>2、新增文件素材模版及详情功能</p>
        <p>3、新增稿件类型--广播稿</p>
        <p>4、优化新媒体稿内容为空样式</p>
        <p>5、topic、interview、clue、report模块名称接受动态配置</p>
        <p>6、对接公共服务平台语音合成功能模块</p>
        <p>7、首页待处理区支持非固定数量内容，并提供切换功能</p>
        <p>8、部门考评、栏目考评新增清空打分功能</p>
        <p>9、栏目考评新增播出日期信息</p>
        <p>10、部门统计支持按照播出时间/发布时间排序</p>
        <p>11、后台管理网站增加权限和菜单：隐藏/重命名功能</p>
        <p>12、后台管理增加新增pc菜单功能</p>
        <p>13、后台网站增加用户默认头像配置</p>
        <p>14、后台网站增加网站title设置</p>
        <p>15、后台网站角色人员配置完善，可多选添加用户角色权限</p>
        <p>16、考评打分部门统计和导出增加播出时间字段</p>
        <p>17、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.144 - 20200206</p>
        <p>web端：</p>
        <p>1、栏目考评播出日期筛选调整为时间段</p>
        <p>2、部门统计列表新增“播出栏目”信息</p>
        <p>3、稿件草稿自动保存逻辑优化</p>
        <p>4、相关日志归类</p>
        <p>5、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.142 - 20200106</p>
        <p>web端：</p>
        <p>1、新增串联单详情页</p>
        <p>2、电视报片支持直接跳转“已播出”报片列表</p>
        <p>3、检索优化</p>
        <p>4、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.139 - 20191220</p>
        <p>web端：</p>
        <p>1、新增部门考评功能</p>
        <p>2、新增部门统计功能</p>
        <p>3、新增个人统计功能</p>
        <p>4、栏目考评增加导出打分功能</p>
        <p>5、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.138 - 20191213</p>
        <p>web端：</p>
        <p>1、新增栏目考评功能</p>
        <p>2、针对上传时文件名过长的情况做截取处理</p>
        <p>3、针对chrome浏览器cookie策略根据版本进行处理</p>
        <p>4、账户密码传输过程中进行加密处理</p>
        <p>5、后台网站编辑部门增加考评打分部门配置</p>
        <p>6、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.137 - 20191206</p>
        <p>web端：</p>
        <p>1、后台网站部门管理列表修改，增加部门详情页</p>
        <p>2、电视报片列表进入详情加入权限判断</p>
        <p>3、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.136 - 20191129</p>
        <p>web端：</p>
        <p>1、采访库/报道库部门筛选展示修改（原来只有区县台显示子部门 现在修改为有子部门都会显示）</p>
        <p>2、报道库看看查询逻辑修改（减少一个接口调用）</p>
        <p>3、管理后台权限管理子菜单（接口/菜单/权限管理）移动至系统权限，只对管理员显示</p>
        <p>4、兼容未来chrome版本用户信息跨域限制</p>
        <p>5、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.135 - 20191121</p>
        <p>web端：</p>
        <p>1、数据中心新增电视报片模块</p>
        <p>2、提案库新增提案详情预览功能，列表样式调整</p>
        <p>3、针对采访库筛选部门过多的情况做了折叠处理</p>
        <p>4、后台权限管理新增电视报片统计权限</p>
        <p>5、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.134 - 20191115</p>
        <p>web端：</p>
        <p>1、线索/报道备注最大设置为200字</p>
        <p>2、后台监控管理增加系统日志，按报道/线索/采访标题检索</p>
        <p>3、后台监控管理-微服务回调-转码回调增加文件来源线索/报道信息</p>
        <p>4、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.133 - 20191108</p>
        <p>web端：</p>
        <p>1、采访库列表新增支持按部门筛选</p>
        <p>2、资源分配车辆和人员时按照字母和数字排序</p>
        <p>3、资源分配列表支持修改采访备注</p>
        <p>4、已删除稿件（策划、采访、线索、报道）不再能够进入详情页</p>
        <p>5、修复旧版火狐上电视稿无法提交内容的问题</p>
        <p>6、修复旧版火狐上用户名片无法显示的问题</p>
        <p>7、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.132 - 20191101</p>
        <p>web端：</p>
        <p>1、报道库列表支持“区县台”下二级筛选</p>
        <p>2、报道/线索稿件详情视频素材转码失败时支持原始码流下载</p>
        <p>3、报道/线索稿件视频/音频素材插入功能优化</p>
        <p>4、后台网站监控管理增加检索引擎异常监控并可以手动处理</p>
        <p>5、后台网站信息维护模块也可以手动同步检索引擎</p>
        <p>6、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.131 - 20191024</p>
        <p>web端：</p>
        <p>1、后台网站考评打分模块移动至信息维护模块，对于运维管理角色权限管理模块只开放 用户管理/权限管理/组织架构</p>
        <p>2、后台网站通知维护->web首页公告编辑器放大</p>
        <p>3、后台网站通知维护->web首页公告发布时间选择精确到分钟</p>
        <p>4、后台网站通知维护->web首页公告按发布时间倒序排序，同接口</p>
        <p>5、修复后台网站列表页面操作区域被折叠的问题</p>
        <p>6、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.130 - 20191018</p>
        <p>web端：</p>
        <p>1、新建策划页、新建/编辑采访页提交成功提示并2秒后自动关闭</p>
        <p>2、修复火狐浏览器下部分新开页面被拦截的问题</p>
        <p>3、对策划库、我的策划、我的采访列表备注进行样式调整，过长的备注将不再影响布局</p>
        <p>4、采访的一生、报道的一生针对不同数据长度进行显示优化</p>
        <p>5、报道/线索历史版本记录时间修改为记录上一版本时间</p>
        <p>6、线索库标签按线索类型区分</p>
        <p>7、pc/app验证码文字放大</p>
        <p>8、大屏接口按用户需求修改</p>
        <p>9、后台网站-用户列表增加用户批量导入功能</p>
        <p>10、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.129 - 20191011</p>
        <p>web端：</p>
        <p>1、策划模块、采访模块进入详情页、编辑页方式改为新开窗口</p>
        <p>2、报道/线索编辑页多媒体上传时取消图片数量限制</p>
        <p>3、资源分配摄像时，新增任务类型选择功能</p>
        <p>4、人员详情页分配记录中新增“任务类型”信息</p>
        <p>5、报道/线索详情页新增“添加/新增警示”功能，并展示警示信息</p>
        <p>6、报道/线索列表新增警示图标</p>
        <p>7、后台网站增加角色列表增加手动同步功能</p>
        <p>8、组织架构仅读取权限中心中的“融媒体中心”</p>
        <p>9、后台网站监控管理-操作日志分页错误和ip地址记录错误修复</p>
        <p>10、后台网站监控管理-下载日志新增ip地址记录</p>
        <p>11、日志记录bug修复</p>
        <p>12、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.128 - 20190927</p>
        <p>web端：</p>
        <p>1、新增用户名片：首页（最近线索/最近报道/资源分配），策划（策划库/策划详情），采访（采访库/采访审核/采访详情/审核详情），线索（渠道线索/自采线索/线索详情），报道（报道库/报道审核/报道详情/审核详情），资源管理（资源分配）</p>
        <p>2、资源分配（司机/摄像）时人员忙碌状态根据筛选时间显示</p>
        <p>3、采访模块和报道模块进入编辑页按钮点击时增加状态判断</p>
        <p>4、设备管理/人员管理筛选逻辑修改为根据设备和人员当前是否有任务展示</p>
        <p>5、后台网站新增用户解锁功能</p>
        <p>6、错别字检测功能优化，现在会一次性标注出所有错别字</p>
        <p>7、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.127 - 20190919</p>
        <p>web端：</p>
        <p>1、审核采访/报道页、编辑采访/报道页底部新增“修改并通过”功能</p>
        <p>2、线索/报道详情页多媒体区显示优化，自动定位到第一项有资源的类别</p>
        <p>3、资源分配时间筛选修改，支持范围时间；导出表格显示导出时间段</p>
        <p>4、资源分配已分配任务按开始时间正序排列</p>
        <p>5、个人中心-账号安全新增改密提示</p>
        <p>6、收录线索页新增“收录单”功能</p>
        <p>7、报道/线索详情页扩展信息新增“收录时间”字段</p>
        <p>8、线索/报道编辑页提交按钮增加防误触限制，防止多次提交</p>
        <p>9、后台网站增加在线人数统计</p>
        <p>10、稿件编辑页上传通道切换功能优化，高速通道帮助页新增新版chrome变化</p>
        <p>11、资源管理列表待审核状态任务支持修改开始/结束时间</p>
        <p>12、推送文件单引号问题修改</p>
        <p>13、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.126 - 20190910</p>
        <p>web端：</p>
        <p>1、所有列表标题鼠标悬停显示全部内容</p>
        <p>2、所有列表页面页码新增显示总条数</p>
        <p>3、资源分配列表高度减小</p>
        <p>4、网站导航菜单红点提示性能优化</p>
        <p>5、优化修改to avid流程</p>
        <p>6、其他bug修复及体验优化</p>
        <p>app端：</p>
        <p>安卓（v1.15.2）：</p>
        <p>1、修复首页采访统计点击跳转</p>
        <p>2、修复小米照相无法跳转预览页</p>
        <p>3、修复稿件编辑页未加载完全时点击导致崩溃</p>
        <p>4、修复电视稿媒体库上传或删除素材可能出现插入正文按钮</p>
        <p>5、修复稿件详情页内容中音频和媒体库音频可以同时播放</p>
        <p>6、修复报道编辑页、详情页tag字段显示null</p>
        <p>7、修复转发报道关联策划、线索无法删除</p>
        <p>8、修复稿件素材上传失败后无法彻底删除</p>
        <p>9、修复4g环境无法获取稿件编辑页数据</p>
        <p>10、修复4g环境无法获取线索详情</p>
        <p>11、修复添加看看三件套无效</p>
        <p>12、优化界面部分ui</p>
        <p>13、优化自动保存条件</p>
        <p>14、优化关联线索详情页推报道按钮显示</p>
        <p>15、添加采访撤销功能</p>
        <p>16、添加用户名片功能</p>
        <p>17、添加音频列表语音转文字长按复制功能</p>
      </div>
      <div class="gen">
        <p>v2.0.0.125 - 20190905</p>
        <p>web端：</p>
        <p>1、我的采访“已退回”状态改为“待处理”</p>
        <p>2、我的采访待审核状态新增“撤回”功能，撤回后仅发布者可见，可编辑或删除</p>
        <p>3、首页外链新增“流程监控”入口</p>
        <p>4、新建采访/新建策划页面新增“取消”按钮用于返回上一页</p>
        <p>5、to avid去除不能作为文件名的字符</p>
        <p>6、新建/编辑采访时间选择单位支持到分钟</p>
        <p>7、网站logo替换为正式版</p>
        <p>8、其他bug修复及体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.124 - 20190830</p>
        <p>web端：</p>
        <p>1、线索/报道详情页新增稿件拓展信息</p>
        <p>2、首页待处理区域数值修改，跳转列表对应状态调整</p>
        <p>3、线索/报道列表显示时间以及排序修改</p>
        <p>4、采访模块暂时隐藏更新提示icon</p>
        <p>5、我的线索/我的报道隐藏新记录提示icon</p>
        <p>6、关联线索未保存直接退出情况下不再保存多媒体文件</p>
        <p>7、我的采访列表开放删除功能</p>
        <p>8、线索列表样式调整</p>
        <p>9、线索/报道的编辑/详情页内容部分最小宽度调整为1100，优化窗口过小时显示样式</p>
        <p>10、后台管理网站搜索功能修复</p>
        <p>11、其他bug修复及体验优化</p>
        <p>app端：</p>
        <p>IOS：</p>
        <p>1、清除缓存（需求）</p>
        <p>2、优化移动网络下保存草稿的频率（新功能）</p>
        <p>3、录音返回提醒（需求）</p>
        <p>4、优化修复自动保存的提示框没有真正在window上移除（有重叠）</p>
        <p>5、优化修改我的界面在重复覆盖问题</p>
        <p>6、优化互联网线索微博有图片的推报道crash collapse</p>
        <p>7、优化地址显示html内容</p>
        <p>8、修复bug</p>
        <p>安卓：</p>
        <p>1、修复更新报道关联线索直接退出后素材清理</p>
        <p>2、修复稿件插入音频后没有标题</p>
        <p>3、修复线索推报道内容丢失</p>
        <p>4、添加稿件编辑删除素材后，文字内容合并</p>
        <p>5、添加自动保存登录账号密码</p>
        <p>6、添加清除缓存功能</p>
        <p>7、优化自动保存时间间隔控制</p>
      </div>
      <div class="gen">
        <p>v2.0.0.123 - 20190823</p>
        <p>web端：</p>
        <p>1、优化网站菜单刷新和红点提示逻辑，提高性能</p>
        <p>2、稿件中音频替换为自定义播放器并且兼容客户端</p>
        <p>3、新版错别字检测功能上线</p>
        <p>4、后台网站信息管理菜单整理，增加按标题搜索</p>
        <p>5、线索/报道列表筛选条件已选项改为横向排列</p>
        <p>6、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>IOS：</p>
        <p>1、修复稿件光标定位问题，优化光标样式</p>
        <p>2、修复文稿插入素材问题</p>
        <p>3、调整键盘类型，修复文字显示问题</p>
        <p>4、适配iphone X工具条</p>
        <p>5、修复菜单显示问题</p>
        <p>6、部分文案调整</p>
        <p>7、其他bug修复和体验优化</p>
        <p>安卓：</p>
        <p>1、修复关联线索列表页为空</p>
        <p>2、相册禁用gif格式</p>
        <p>3、优化新建采访界面ui</p>
        <p>4、优化稿件编辑页滚动及光标定位</p>
        <p>5、增加报道上下架消息推送</p>
        <p>6、其他bug修复和体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.122 - 20190819</p>
        <p>web端：</p>
        <p>1、线索/报道编辑页上传素材功能显示速度和比率数值</p>
        <p>2、线索/报道编辑页新增“传完自动发布/送审”功能</p>
        <p>3、看看发布页时间筛选限制30天以内的数据</p>
        <p>4、线索/报道详情页素材列表视频素材新增“进入画中画”功能</p>
        <p>5、策划/线索/报道编辑页的标签长度限制为8个字</p>
        <p>6、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>IOS：</p>
        <p>1、优化菜单的获取方法</p>
        <p>2、上传优化&多媒体库删除按钮icon修改&返回确定按钮修改&新建采访的记者默认显示</p>
        <p>3、优化多媒体插入过程，流畅</p>
        <p>4、优化上传&默认的图片</p>
        <p>5、设置光标位置在多媒体后</p>
        <p>6、iphonex工具条显示适配</p>
        <p>7、改变感叹号问题</p>
        <p>8、视频封面</p>
        <p>9、优化自动保存，有内容才保存</p>
        <p>10、新建采访-没有默认显示记者，需要再点进去确认，才能提交</p>
        <p>11、报片/线索，上传视频的缩略图读取错误</p>
        <p>12、多媒体库-返回按钮改成确认</p>
        <p>13、多媒体库-删除icon都变小红点的红色</p>
        <p>安卓：</p>
        <p>1、优化文件上传策略</p>
        <p>2、优化插入稿件素材上传百分比显示</p>
        <p>3、修改媒体库按钮样式</p>
        <p>4、修复报道库更新提示逻辑</p>
        <p>5、优化稿件自动更新策略</p>
        <p>6、添加打开我的报道、我的线索已完成详情后刷新列表逻辑</p>
        <p>7、修复微博推报道返回首页问题</p>
        <p>8、修复可能无法删除上传中的素材以及删除后状态异常</p>
      </div>
      <div class="gen">
        <p>v2.0.0.121 - 20190809</p>
        <p>web端：</p>
        <p>1、报道送审逻辑修改，增加送审推送平台选择弹框</p>
        <p>2、资源分配页面增加已过期筛选项及相关操作</p>
        <p>3、隐藏资源分配菜单小红点</p>
        <p>4、后台增加权限中心同步刷新功能（用户/组织结构）</p>
        <p>5、部门读写，仅读取权限中心配置在xnews下的部门</p>
        <p>6、各模块符号转义错误统一排查处理</p>
        <p>7、采访详情增加跳转关联页面的权限判断</p>
        <p>8、针对xp系统/chrome49版本进行系列兼容性修复</p>
        <p>9、隐藏线索推送系统弹窗</p>
        <p>10、线索各模块和报道库增加刷新功能</p>
        <p>11、错别字检测功能针对新版稿件编辑器调整</p>
        <p>12、其他bug修复和体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.120 - 20190802</p>
        <p>web端：</p>
        <p>1、文稿语音合成增加交互动作</p>
        <p>2、新建采访时默认时间修改优化</p>
        <p>3、新建采访时选择默认部门</p>
        <p>4、电视稿编辑页样式优化</p>
        <p>5、长图支持放大预览</p>
        <p>6、针对xp系统/chrome49版本进行系列兼容性修复</p>
        <p>7、数据中心模块加入后台权限管理配置</p>
        <p>8、数据中心增加文稿导出功能</p>
        <p>9、稿件类型转换bug修复</p>
        <p>10、app端稿件增加可编辑判断</p>
        <p>11、大屏接口对接（完成至17个）</p>
        <p>12、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>IOS：</p>
        <p>1、修改资源分配选择时间</p>
        <p>2、新建采访自动选择部门</p>
        <p>3、禁用pc编辑过的新媒体稿</p>
        <p>4、发布时取消自动保存</p>
        <p>5、修复其他bug</p>
        <p>安卓：</p>
        <p>1、修复编辑线索无法排序</p>
        <p>2、修复删除草稿没有提示</p>
        <p>3、修复线索筛选标签显示不全</p>
        <p>4、修复新建采访默认时间未生效</p>
        <p>5、优化录音界面ui</p>
        <p>6、优化短信登录发送验证码逻辑</p>
        <p>7、添加连线功能</p>
        <p>8、添加拨打采访摄像、司机电话功能</p>
      </div>
      <div class="gen">
        <p>v2.0.0.119 - 20190726</p>
        <p>web端：</p>
        <p>1、报道库线索库标题和正文修改为多关键检索</p>
        <p>2、新增数据中心——看看发布模块</p>
        <p>3、后台日志增加发送失败日志</p>
        <p>4、报道详情页增加转发按钮</p>
        <p>5、发布报道增加推送平台弹框选择</p>
        <p>6、修复文稿转换换行符bug</p>
        <p>7、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>IOS：</p>
        <p>1、新增资源分配电话可以打</p>
        <p>2、发布稿件时增加发送平台的判断</p>
        <p>3、新增没有图片新媒体封面显示2/3</p>
        <p>4、新建新媒体没有富文本</p>
        <p>5、对接苹果推送消息</p>
        <p>6、修复上传视频附件，在上传中，切换到文稿界面，视频不显示</p>
        <p>7、修复其他bug</p>
      </div>
      <div class="gen">
        <p>v2.0.0.118 - 20190718</p>
        <p>web端：</p>
        <p>1、网站菜单小红点取消逻辑优化：切换时小红点实时取消</p>
        <p>2、网站菜单切换逻辑优化：当前页再次点击可刷新</p>
        <p>3、稿件类型拆分：分离电视稿和新媒体稿（通稿）；新建/推送/转发报道时需选择类型；线索仅提供新媒体稿</p>
        <p>4、电视稿编辑器修改：仅支持纯文本，模版取消“记者”、“摄像”内容</p>
        <p>5、稿件编辑/新建/详情页新增“记者”、“摄像”字段</p>
        <p>6、修复推送报道/关联线索时出现多篇报道的bug</p>
        <p>7、取消稿件提交时内容不为空的限制</p>
        <p>8、针对APP数据类型兼容处理，保持多端一致</p>
        <p>9、转发（复制报道）接口转换</p>
        <p>10、隐藏推送至功能按钮</p>
        <p>11、隐藏报道推送平台选择，改为发布后自动读取配置推送</p>
        <p>12、多媒体文件下载日志增加关联报道和线索信息</p>
        <p>13、app首页接口修改</p>
        <p>14、后台网站增加稿件类型推送平台配置</p>
        <p>15、线索增加简介字段</p>
        <p>16、大屏数据接口1-6完善开发</p>
        <p>17、资源管理列表默认取明天的数据</p>
        <p>18、推送avid文件标题bug修复</p>
        <p>19、pc/app信源订阅修改为信源</p>
        <p>20、pc/app互联网线索隐藏关键字</p>
        <p>21、导出excel表格格式优化</p>
        <p>22、采访模块隐藏上传线索入口</p>
        <p>23、采访模块隐藏线索上传筛选</p>


        <p>app端：</p>
        <p>安卓：</p>
        <p>1、更新稿件类型选择框样式</p>
        <p>2、更名通稿为新媒体稿</p>
        <p>3、电视稿类型改为纯文本模式</p>
        <p>4、禁止电视稿媒体素材插入正文</p>
        <p>5、线索、报道增加记者、摄像字段</p>
        <p>6、电视稿编辑界面删除封面区块</p>
        <p>7、电视稿禁止排序</p>
        <p>8、线索上传固定新媒体稿类型</p>
        <p>9、更新部分按钮文字</p>
        <p>10、更新首页统计数据显示样式</p>
        <p>11、调整发布页面按钮顺序</p>
        <p>12、体验优化和bug修复</p>

        <p>IOS:</p>
        <p>1、音频，视频，图片，多文件上传，优化和改名字</p>
        <p>2、去除首页发布</p>
        <p>3、发送改为复制功能</p>
        <p>4、电视稿修改</p>
        <p>5、提示浮层样式统一问题</p>
        <p>6、写报道/传线索页面,底部的按钮点击</p>
        <p>7、视频库样式问题</p>
        <p>8、编辑页面中删除样式未对齐</p>
        <p>9、音频库优化</p>
        <p>10、策划详情页，底部关联的采访，线索，报道列表需要有滚动效果</p>
        <p>11、体验优化和bug修复</p>

      </div>
      <div class="gen">
        <p>v2.0.0.117 - 20190704</p>
        <p>web端：</p>
        <p>1、视频预览支持2倍、4倍播放速度</p>
        <p>2、修复线索列表筛选条件联动bug</p>
        <p>3、兼容处理部门推送平台为空情况</p>
        <p>4、报道送审和发布权限控制拆分</p>
        <p>5、修复保存/发布稿件时提示内容为空的bug</p>
        <p>6、推送平台根据部门后台可配置</p>
        <p>7、暂时移除CPTN线索的高清素材下载权限</p>
        <p>8、线索信源显示排序后台可配置</p>
        <p>9、后台多媒体文件下载的监控日志</p>
        <p>10、报道回推线索bug修复</p>
      </div>
      <div class="gen">
        <p>v2.0.0.116 - 20190628</p>
        <p>web端：</p>
        <p>1、修复多媒体预览弹窗关闭后继续播放的问题</p>
        <p>2、推送报道页标题更正</p>
        <p>3、修复线索/报道列表筛选条件切换后数据有误的问题</p>
        <p>4、关联策划/采访/线索功能优化，将接口调用时机改为打开弹窗时</p>
        <p>5、自动保存逻辑优化</p>
        <p>6、稿件列表封面图加载出错时替换为默认图</p>
        <p>7、多媒体素材上传模块优化，素材列表改为由接口获取</p>
        <p>8、修复列表搜索功能在当前页码不为1时搜索结果有误的问题</p>
        <p>9、稿件详情页视频最大宽度优化</p>
        <p>10、添加人员/设备窗口优化，多次打开时清除上次操作痕迹</p>
        <p>11、推送报道编辑页优化，完善推送信息</p>
        <p>12、渠道线索生成的报道标题按需求截取</p>
        <p>13、稿件“to快编”接入权限</p>
        <p>14、线索库菜单列表权限配置</p>
        <p>15、报道入库反推线索库</p>
        <p>16、线索库信源整理</p>
        <p>17、APP上方的总量统计，策划隐藏</p>
        <p>app端：</p>
        <p>安卓：</p>
        <p>1、修复稿件编辑页添加素材后可能出现两次相同文字内容</p>
        <p>2、修复报道关联线索后未复制线索媒体库素材</p>
        <p>3、修复空列表显示样式异常</p>
        <p>4、修复退回采访无法编辑</p>
        <p>5、修复编辑退回采访时部分字段未赋值</p>
        <p>6、修复更新线索的信源未同步</p>
        <p>7、修复策划编辑页文字错误</p>
        <p>8、修复我的报道列表界面缺少显示数据</p>
        <p>9、修复拍照界面第一次打开相机无法预览</p>
        <p>10、优化媒体库界面素材上传界面数据更新逻辑</p>
        <p>11、优化资源管理分配逻辑</p>
        <p>12、优化稿件编辑界面软键盘界面显示</p>
        <p>13、优化从素材穿线索、发报道跳转编辑界面内容显示</p>
        <p>14、添加资源管理点击标题跳转详情页</p>
        <p>15、添加稿件详情关联内容访问权限提示</p>
        <p>IOS:</p>
        <p>1、修复音频播放问题，重写录音</p>
        <p>2、修复线索不能带入多媒体的问题</p>
        <p>3、修复编辑器没有点击区域的问题</p>
        <p>4、采访详情页-记者、司机、摄像，文字宽度太小</p>
        <p>5、稿件锁，点返回---不需要提示</p>
        <p>6、ios-资源分配-多人分配缺少…显示</p>
        <p>7、传线索---添加封面---上传图片—闪退</p>
        <p>8、传线索--封面丢失、标签会丢</p>
        <p>9、ios 报道详情页，点击关联采访、线索，闪退，无法进入详情页</p>
        <p>10、“我的”列表文字没有对齐</p>
        <p>11、创建线索信源添加不上导致发布不了的问题</p>
        <p>12、报道详情推送部门不能点击问题</p>
      </div>
      <div class="gen">
        <p>v2.0.0.115 - 20190624</p>
        <p>web端：</p>
        <p>1、线索筛选条件联动问题修复</p>
        <p>2、修复采访详情页布局样式问题</p>
        <p>3、页码组件兼容更大数目</p>
        <p>4、修复报道“推送至”功能部门信息错误导致推送目录错误的bug</p>
        <p>5、修复线索库部分频道检索无效的bug</p>
        <p>6、修复采访一生节点记录错误的bug</p>
        <p>7、修复关键字检索不支持空格和引号的bug</p>
      </div>
      <div class="gen">
        <p>v2.0.0.114 - 20190621</p>
        <p>web端：</p>
        <p>1、修复用户修改头像失败问题</p>
        <p>2、报道库推送至看看修改icon和推送记录显示修改</p>
        <p>3、线索推送报道转码回调图片bug修复</p>
        <p>4、上传线索信源隐藏“线索上传”和“媒资”，增加默认选项“请选择”</p>
        <p>5、app端新增大文件上传参数配置接口</p>
        <p>6、app接口时间格式按照新版设计修改</p>
        <p>7、修复to电视多媒体文件名过长、特殊字符的问题</p>
        <p>8、修复to电视视频分类问题</p>
        <p>9、修复“推送报道/关联线索”时电视稿内容留白过大问题</p>
        <p>10、插入视频时增加封面用于app端显示</p>
        <p>app端：</p>
        <p>暂无</p>
      </div>
      <div class="gen">
        <p>v2.0.0.113 - 20190614</p>
        <p>web端：</p>
        <p>1、稿件列表新建和改动提示实时更新</p>
        <p>2、配置更新发短信模版</p>
        <p>3、音视频文件名过滤处理</p>
        <p>4、稿件编辑页下拉菜单操作优化</p>
        <p>5、上传素材数量每类限制10个</p>
        <p>6、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>Android：</p>
        <p>1、修复稿件编辑页发布界面关联线索闪退</p>
        <p>2、修复稿件编辑在文字中插入素材可能导致第二行文字丢失</p>
        <p>3、修复稿件详情界面封面尺寸异常</p>
        <p>4、修复采访库叹号提示规则错误</p>
        <p>5、修复采访库时间显示格式</p>
        <p>6、修复app从后台切到前台返回主页问题</p>
        <p>7、修复报道库筛选默认选择原创</p>
        <p>8、修复送审界面按钮文字错误</p>
        <p>9、修复稿件详情视频无法播放</p>
        <p>10、优化界面UI</p>
        <p>11、添加移动网络同步频率</p>
        <p>12、添加推送通知开关</p>
        <p>13、增加扫码登录低版本系统适配</p>
        <p>IOS:</p>
        <p>1、修复了部分bug</p>
        <p>2、添加忘记密码功能</p>
        <p>3、修复手机登录</p>
      </div>
      <div class="gen">
        <p>v2.0.0.112 - 20190613</p>
        <p>web端：</p>
        <p>1、提供avid素材查询接口</p>
        <p>2、对pc和app富文本内容处理</p>
        <p>3、音视频文件名过滤处理</p>
        <p>4、微博线索列表支持预览</p>
        <p>5、更新app下载二维码（正式版）</p>
        <p>6、线索列表筛选模块间距调整</p>
        <p>7、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>暂无</p>
      </div>
      <div class="gen">
        <p>v2.0.0.111 - 20190611</p>
        <p>web端：</p>
        <p>1、登录页登录方式支持配置</p>
        <p>2、音视频转文字增加失败状态并支持重试</p>
        <p>3、更新app下载二维码（测试版）</p>
        <p>4、修复稿件上传多媒体文件并发问题</p>
        <p>5、报道关联电视稿线索兼容其他格式</p>
        <p>6、avid检索线索接口更新</p>
        <p>7、新建报道日志记录信息完善</p>
        <p>8、微博采集下载图片、视频</p>
        <p>9、语音合成对接新服务</p>
        <p>10、修改转码回调程序报错问题</p>
        <p>11、avid回推入库处理</p>
        <p>12、日志按客户需求完善</p>
        <p>13、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>暂无</p>
      </div>
      <div class="gen">
        <p>v2.0.0.110 - 20190605</p>
        <p>web端：</p>
        <p>1、报道库增加“只看原创”筛选功能</p>
        <p>2、报道库/我的报道新增“复制报道”功能</p>
        <p>3、部分提示文案调整</p>
        <p>4、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>暂无</p>
      </div>
      <div class="gen">
        <p>v2.0.0.109 - 20190604</p>
        <p>web端：</p>
        <p>1、报道推送平台改为必填，默认为“电视”</p>
        <p>2、由线索创建报道修改为“推送报道”</p>
        <p>3、报道送审逻辑修改</p>
        <p>4、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>暂无</p>
      </div>
      <div class="gen">
        <p>v2.0.0.108 - 20190603</p>
        <p>web端：</p>
        <p>1、日志完善处理</p>
        <p>2、对接crm部分接口post处理</p>
        <p>3、记录下载多媒体文件日志</p>
        <p>4、地理位置信息显示优化</p>
        <p>5、稿件锁界面和逻辑调整</p>
        <p>6、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>暂无</p>
      </div>
      <div class="gen">
        <p>v2.0.0.107 - 20190531</p>
        <p>web端：</p>
        <p>1、对接国际通道上传</p>
        <p>2、上传参数接口配置</p>
        <p>3、修复文本编辑器插入视频等尺寸问题</p>
        <p>4、修复错别字样式问题</p>
        <p>5、修改音频转码逻辑问题</p>
        <p>6、系统提示错误信息优化</p>
        <p>7、提供大屏数据对接基础版接口</p>
        <p>8、管理后台首页露出</p>
        <p>9、运管、超管权限控制</p>
        <p>10、提供快编检索素材接口</p>
        <p>11、上传、转码、推送等多媒体文件目录调整</p>
        <p>app端：</p>
        <p>暂无</p>
      </div>
      <div class="gen">
        <p>v2.0.0.106 - 20190524</p>
        <p>web端：</p>
        <p>1、新增稿件锁功能</p>
        <p>2、时间选择器优化</p>
        <p>3、个人中心新增修改手机号/邮箱功能</p>
        <p>4、新增互联网线索入库提示弹窗</p>
        <p>5、报道看看数接口优化，支持跳转</p>
        <p>6、线索列表筛选条件样式调整</p>
        <p>7、互联网信源订阅修改为一级信源</p>
        <p>8、稿件多媒体下载高低码率权限修改</p>
        <p>9、其他bug修复和体验优化 </p>
        <p>app端：</p>
        <p>1、app检索性能优化</p>
        <p>2、安卓新增稿件锁功能</p>
        <p>3、安卓个人中心新增修改手机号/邮箱功能</p>
        <p>4、ios接入用户权限</p>
        <p>5、ios支持音视频素材预览</p>
        <p>6、ios上传管理优化</p>
        <p>7、ios接入消息推送</p>
        <p>8、ios支持扫码登录</p>
        <p>9、其他bug修复和体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.105 - 20190517</p>
        <p>web端：</p>
        <p>1、首页公告布局调整</p>
        <p>2、首页快捷方式接入</p>
        <p>3、所有列表操作按钮固定显示</p>
        <p>4、稿件详情页资源下载支持“800K”和“原始”两种码率</p>
        <p>5、权限控制优化</p>
        <p>6、支持扫码登录</p>
        <p>7、多媒体文件上传、入库、转码状态实时更新</p>
        <p>8、app发布按钮权限控制</p>
        <p>9、其他bug修复和体验优化</p>
        <p>app端：</p>
        <p>1、安卓增加音频预览界面</p>
        <p>2、安卓支持扫码登录</p>
        <p>3、文稿编辑更改图片和音视频浏览删除交互方式</p>
        <p>4、安卓发布增加拍照功能</p>
        <p>5、ios增加音频库</p>
        <p>6、ios富文本编辑器优化</p>
        <p>7、其他bug修复和体验优化</p>
      </div>
      <div class="gen">
        <p>v2.0.0.104 - 20190510</p>
        <p>web端：</p>
        <p>1、解决推送至avid，正文 导语等颜色问题</p>
        <p>2、解决mac导出word乱码的问题</p>
        <p>3、推送至avid发布者为当前操作者，部门为选择部门</p>
        <p>4、同一报道推送至avid 3天5次的限制</p>
        <p>5、互联互通已报道名称+时间作为任务名称</p>
        <p>6、记录报道的流程日志到目录文件</p>
        <p>7、线索/报道上传默认设置为电视稿</p>
        <p>8、添加菜单栏小红点提示（实时更新需等到周一 5.13号后可用）</p>
        <p>9、线索库接口信源权限校验以及后台配置页面</p>
        <p>10、选题改为策划</p>
        <p>11、稿件关联线索功能优化</p>
        <p>12、文稿支持自动保存</p>
        <p>13、电视稿添加内容实时检测提示</p>
        <p>14、页面切换后回到顶部</p>
        <p>15、音视频转文字详情支持导出</p>
        <p>16、稿件列表支持多媒体文件预览</p>
        <p>17、多媒体上传功能模块重构</p>
        <p>18、登陆页logo更新以及其他样式和体验优化</p>
        <p>app端：</p>
        <p>1、增加我的消息页面</p>
        <p>2、增加设置项效果关联</p>
        <p>3、增加推送功能</p>
        <p>4、增加帮助列表及详情</p>
        <p>5、增加菜单权限控制</p>
        <p>6、增加详情页关联内容页面跳转</p>
        <p>7、增加稿件详情页媒体库内容预览</p>
        <p>8、接入连线sdk</p>
        <p>9、优化首页banner逻辑</p>
        <p>10、优化选题详情关联列表样式</p>
        <p>11、优化登录界面输入框样式</p>
        <p>12、优化稿件编辑页内容过长自动滑动至底部问题</p>
        <p>13、修复发布线索选择二级信源无法输入bug</p>
        <p>14、修复资源分配完成页面不刷新bug</p>
        <p>15、修复录音转文字功能</p>
        <p>16、修复后台下载重复添加任务bug</p>
        <p>17、修复我的报道列表跳转编辑页逻辑</p>
        <p>18、修复用户信息更新不及时bug</p>
        <p>19、修复登录相关接口验证码无效bug</p>
      </div>

      <div class="gen">
        <p>v2.0.0.103 - 20190422</p>
        <p>web端：</p>
        <p>1、实时同步检索引擎</p>
        <p>2、微服务、检索引擎、流程引擎、权限中心对接正式环境</p>
        <p>3、正式环境、测试环境分割</p>
        <p>app端：</p>
        <p>暂无</p>
      </div>

      <div class="gen">
        <p>v2.0.0.102 - 20190419</p>
        <p>web端：</p>
        <p>1、新版权限的升级配置与管理</p>
        <p>2、采访、首页模块接入检索引擎</p>
        <p>3、帮助中心上线</p>
        <p>4、修复部分报道库、线索库等bug</p>
        <p>5、网站布局调整（侧边栏和标题栏固定，最小宽度调整）</p>
        <p>6、新增：帮助中心页，公告详情页，采访审核页，报道审核页</p>
        <p>7、新权限逻辑对接优化</p>
        <p>8、稿件编辑优化</p>
        <p>9、错别字检测功能</p>
        <p>10、其他逻辑和样式优化</p>
        <p>app端：</p>
        <p>1、优化后台文件上传逻辑</p>
        <p>2、修复首页拍摄视频发布报道跳转问题</p>
      </div>

      <div class="gen">
        <p>v2.0.0.101 - 20190408</p>
        <p>1、更新多媒体文件上传配置文件</p>
        <p>2、修复上传线索、报道创建无法上传图片、视频、音频、文件、等问题</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import * as config from '@common/config'

export default {
  name: "version",
  data() {
    return {
      list: []
    };
  },
  methods: {
    getData() {
      // const info = {
      //   phone: tel,
      //   action: 'binding'
      // }
      common.myFetch(config.apis.version)
      .then((data) => {
        if (data) {
          this.list = data
          console.log(data)
        }
      })
    }
  },
  created() {
    this.getData()
  }
};
</script>

<style lang="less" scoped>
.version {
  padding: 0 30px 30px;
  min-height: 100%;
  overflow: hidden;
  .info {
    border: 1px solid #dcdcdc;
    background-color: #f5f5f5;
    border-radius: 4px;
    padding: 10px;
    .gen {
      margin-bottom: 20px;
      p {
        line-height: 26px;
      }
    }
    .gen:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
